var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIspsBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3449 6.41896H5.86499C3.17734 6.41896 1 8.60247 1 11.2977C1 13.993 3.17734 16.1765 5.86499 16.1765H8.88718",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1976 6.4474C18.1976 3.43939 15.7651 1 12.7656 1C9.76611 1 7.33362 3.43939 7.33362 6.4474V8.10777",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1125 5.57172C19.6095 5.57172 20.8229 6.78857 20.8229 8.28973V9.69422",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8229 9.2052H21.1858C23.108 9.2052 24.6616 10.7689 24.6616 12.6908C24.6616 14.6128 23.1023 16.1765 21.1858 16.1765H19.0935",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9208 16.1822H17.7157",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2572 10.7917C12.0182 10.7917 12.6351 10.173 12.6351 9.4099C12.6351 8.64678 12.0182 8.02815 11.2572 8.02815C10.4963 8.02815 9.87939 8.64678 9.87939 9.4099C9.87939 10.173 10.4963 10.7917 11.2572 10.7917Z",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9207 10.6154V22.2039C11.9207 22.6417 11.5691 22.9943 11.1325 22.9943H7.93457",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5598 10.6097V21.6921H7.94019",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.396 13.8907C19.157 13.8907 19.7739 13.272 19.7739 12.5089C19.7739 11.7458 19.157 11.1272 18.396 11.1272C17.6351 11.1272 17.0182 11.7458 17.0182 12.5089C17.0182 13.272 17.6351 13.8907 18.396 13.8907Z",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7327 13.7201V19.1902C17.7327 19.6281 18.0842 19.9806 18.5208 19.9806H22.8471",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0935 13.7087V18.6728H22.8415",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9222 16.1993V22.2096C13.9222 22.6474 14.2738 23 14.7104 23H17.8346",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2888 17.7289V21.6922H17.8347",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04798 16.1993V19.1447C8.04798 19.5826 7.69643 19.9351 7.25983 19.9351H2.33813",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68714 16.1822V18.6273H2.33813",
    stroke: "#352890",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIspsBlue);
export default __webpack_public_path__ + "static/media/IspsBlue.01dcf558e5ed53d52cca8da7d992e684.svg";
export { ForwardRef as ReactComponent };